import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Redirect from "./Redirect";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route index element={<Redirect />} />
        <Route path="/" element={<Redirect />} />
        <Route path="/enroll" element={<App enroll={true} auth={false} />} />
        <Route path="/auth" element={<App enroll={false} auth={true} />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
